import * as React from 'react';
import styles from './index.less';
import {
  OnChange_Page_Action,
  OnMount_Page_Action as OnMount_Sidebar_Action,
  OnUpdate_Data_Action,
} from '@/models/resourceSider';
import { withRouter } from 'umi';
import { connect } from 'dva';
import { ConnectState, ResourceVersionEditorPageModelState } from '@/models/connect';
import { RouteComponentProps } from 'react-router/index';
import { Dispatch } from 'redux';
import * as AHooks from 'ahooks';
import useUrlState from '@ahooksjs/use-url-state';
import FComponentsLib from '@freelog/components-lib';
import { Space, Badge } from 'antd';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import FDropdownMenu from '@/components/FDropdownMenu';
import {
  ChangeAction,
  SyncAllPropertiesAction,
  UpdateDataSourceAction,
  OnMount_Page_Action,
  OnUnmount_Page_Action,
  OnChange_Version_Action,
} from '@/models/resourceVersionEditorPage';
import fResourceOptionEditor from '@/components/fResourceOptionEditor';
import FResourceOptions from '@/components/FResourceOptions';
import FBraftEditor from '@/components/FBraftEditor';
import BraftEditor, { EditorState } from 'braft-editor';
import FMenu from '@/components/FMenu';
import FViewportCards_Resource from '@/components/FAntvG6/FViewportCards_Resource';
import FMicroAPP_Authorization from '@/components/FMicroAPP_Authorization';
import FSkeletonNode from '@/components/FSkeletonNode';
import fMessage from '@/components/fMessage';
import FHtmlReactParser from '@/components/FHtmlReactParser';
import { Helmet } from 'react-helmet';
import FHotspotTooltip, { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import fFilePreviewer from '@/components/fFilePreviewer';
import FMicroApp_CartoonEditorDrawer from '@/components/FMicroApp_CartoonEditorDrawer';
import img_zip from '@/assets/zip.png';
import img_txt from '@/assets/txt.png';
import img_audio from '@/assets/audio.png';
import img_pdf from '@/assets/pdf.png';
import img_cartoon from '@/assets/cartoon.png';
import img_general from '@/assets/general.png';
import FMicroApp_MarkdownEditorDrawer from '@/components/FMicroApp_MarkdownEditorDrawer';
import FIcons from '@/components/FIcons';
import FAttrsAndConfigs, { IAttrsAndConfigsItem } from '@/components/FAttrsAndConfigs';
import FDropdown from '@/components/FDropdown';
import FSimpleBar from '@/components/FSimpleBar';

interface VersionInfoProps extends RouteComponentProps<{ id: string }> {
  dispatch: Dispatch;
  resourceVersionEditorPage: ResourceVersionEditorPageModelState;
}

function VersionInfo({ dispatch, resourceVersionEditorPage, match }: VersionInfoProps) {
  const [$urlState, set$urlState] = useUrlState<{ version: string }>({
    version: '',
  });
  const [isEditing, setIsEditing] = React.useState<boolean>(false);
  const [editor, setEditor] = React.useState<EditorState>(
    BraftEditor.createEditorState(resourceVersionEditorPage.description),
  );
  const [$customOptionsExpansion, set$customOptionsExpansion] = React.useState<boolean>(false);

  const [$cartoonPreviewerOpen, set$cartoonPreviewerOpen, get$cartoonPreviewerOpen] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$markdownPreviewerOpen, set$markdownPreviewerOpen, get$markdownPreviewerOpen] =
    FUtil.Hook.useGetState<boolean>(false);

  // const [$versionDropdownOpen, set$versionDropdownOpen, get$versionDropdownOpen] =
  //   FUtil.Hook.useGetState<boolean>(false);

  AHooks.useMount(async () => {
    dispatch<OnMount_Sidebar_Action>({
      type: 'resourceSider/onMount_Page',
      payload: {
        resourceID: match.params.id,
      },
    });

    dispatch<OnChange_Page_Action>({
      type: 'resourceSider/onChange_Page',
      payload: {
        page: 'versionInfo',
      },
    });
    dispatch<OnMount_Page_Action>({
      type: 'resourceVersionEditorPage/onMount_Page',
      payload: {
        resourceID: match.params.id,
        version: $urlState.version,
      },
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmount_Page_Action>({
      type: 'resourceVersionEditorPage/onUnmount_Page',
    });
  });

  React.useEffect(() => {
    setEditor(BraftEditor.createEditorState(resourceVersionEditorPage.description));
  }, [resourceVersionEditorPage.description]);

  async function onChange(payload: Partial<ResourceVersionEditorPageModelState>) {
    await dispatch<ChangeAction>({
      type: 'resourceVersionEditorPage/change',
      payload,
    });
  }

  return (
    <>
      <Helmet>
        <title>{`资源及其属性 · ${
          resourceVersionEditorPage.resourceInfo?.resourceName || ''
        }  - Freelog`}</title>
      </Helmet>
      {resourceVersionEditorPage.pageState === 'loading' && (
        <div>
          <div style={{ height: 40 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={860} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: 20 }}>
            <FSkeletonNode width={200} height={150} />
            <FSkeletonNode width={460} height={40} />
          </div>
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
        </div>
      )}

      {resourceVersionEditorPage.version === '' && (
        <div
          className={styles.noData}
          style={{
            height: 'calc(100vh - 70px)',
            display: resourceVersionEditorPage.pageState === 'loaded' ? 'block' : 'none',
          }}
        >
          <div />
          {!resourceVersionEditorPage.draft && (
            <div>
              <FComponentsLib.FTipText type='first' text={'上传资源，开启授权之旅'} />

              <div style={{ height: 30 }} />
              <FHotspotTooltip
                id={'resourceVersionEditorPage.noVersionAndCreateVersion'}
                style={{ left: -44, top: 8 }}
                text={FI18n.i18nNext.t('hotpots_editresource_btn_createnewversion')}
                onMount={() => {
                  fSetHotspotTooltipVisible('resourceVersionEditorPage.noVersionAndCreateVersion', {
                    value: false,
                    effectiveImmediately: false,
                    onlyNullish: false,
                  });
                }}
              >
                <FComponentsLib.FRectBtn
                  size='large'
                  className={styles.btn}
                  onClick={() => {
                    self.open(
                      FUtil.LinkTo.resourceVersionCreator({
                        resourceID: match.params.id,
                      }),
                    );
                  }}
                >
                  上传资源
                </FComponentsLib.FRectBtn>
              </FHotspotTooltip>
            </div>
          )}

          {!!resourceVersionEditorPage.draft && (
            <div>
              <div
                style={{
                  fontSize: 30,
                  color: '#666',
                  lineHeight: '42px',
                }}
              >
                {FI18n.i18nNext.t('versionmngt_empty_msg2')}
              </div>
              <div style={{ height: 40 }} />
              <Space size={40}>
                <FComponentsLib.FTextBtn
                  type={'primary'}
                  onClick={() => {
                    self.open(
                      FUtil.LinkTo.resourceVersionCreator({
                        resourceID: match.params.id,
                      }),
                    );
                  }}
                >
                  {FI18n.i18nNext.t('versionmngt_empty_btn_continueediting')}
                </FComponentsLib.FTextBtn>
                <FComponentsLib.FTextBtn
                  type={'default'}
                  onClick={async () => {
                    const { ret, errCode, msg } = await FServiceAPI.Resource.deleteResourceDraft({
                      resourceId: match.params.id,
                    });
                    if (ret !== 0 || errCode !== 0) {
                      fMessage(msg, 'error');
                      return;
                    }
                    dispatch<ChangeAction>({
                      type: 'resourceVersionEditorPage/change',
                      payload: {
                        draft: null,
                      },
                    });
                  }}
                >
                  {FI18n.i18nNext.t('versionmngt_empty_btn_discard')}
                </FComponentsLib.FTextBtn>
              </Space>
            </div>
          )}
          <div />
        </div>
      )}

      {resourceVersionEditorPage.version !== '' && (
        <div
          style={{
            display: resourceVersionEditorPage.pageState === 'loaded' ? 'block' : 'none',
          }}
        >
          <div>
            <div style={{ height: 40 }} />

            <div className={styles.Header}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <FDropdown
                  // open={$versionDropdownOpen}
                  overlayStyle={{
                    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.2)',
                    maxHeight: 460,
                    // overflowY: 'auto',
                    minWidth: 'auto',
                  }}
                  // onOpenChange={(open) => {
                  //   if (open) {
                  //     set$versionDropdownOpen(true);
                  //   }
                  // }}
                  overlay={
                    <FSimpleBar maxHeight={460} className={styles.versionDropdown}>
                      <FMenu
                        options={resourceVersionEditorPage.versions
                          // options={[
                          //   '1.1.1',
                          //   '2.2.2',
                          //   '3.3.3',
                          //   '4.4.4',
                          //   '5.5.5',
                          //   '6.6.6',
                          //   '7.7.7',
                          //   '8.8.8',
                          //   '9.9.9',
                          //   '10.10.10',
                          //   '11.11.11',
                          //   '12.12.12',
                          //   '13.13.13',
                          //   '14.14.14',
                          //   '15.15.15',
                          //   '16.16.16',
                          //   '17.17.17',
                          //   '18.18.18',
                          //   '19.19.19',
                          //   '20.20.20',
                          // ]
                          .map((v) => {
                            return {
                              value: v,
                              text: v,
                            };
                          })}
                        onClick={(value) => {
                          // onChangeVersion && onChangeVersion(value);
                          if (value !== resourceVersionEditorPage.version) {
                            dispatch<OnChange_Version_Action>({
                              type: 'resourceVersionEditorPage/onChange_Version',
                              payload: {
                                version: value,
                              },
                            });
                          }
                        }}
                      />
                    </FSimpleBar>
                  }
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      cursor: 'pointer',
                    }}
                  >
                    <FComponentsLib.FContentText
                      // text={`当前版本 ${version}`}
                      // text={`${FI18n.i18nNext.t('edit_resource_vmgnt_btn_update')} ${version}`}
                      text={`${FI18n.i18nNext.t('edit_resource_vmgnt_label_currentversion')} ${
                        resourceVersionEditorPage.version
                      }`}
                      type={'highlight'}
                      singleRow
                      style={{ maxWidth: 750, fontSize: 16 }}
                    />
                    {/*<div style={{ width: 8 }} />*/}
                    <FIcons.FDown style={{ fontSize: 12 }} />
                  </div>
                </FDropdown>
                <div style={{ width: 30 }} />
                <Badge
                  count={
                    !!resourceVersionEditorPage.draft //hasDraft
                      ? '草稿'
                      : 0
                  }
                  size={'small'}
                  offset={[20, 0]}
                >
                  <FComponentsLib.FTextBtn
                    style={{ display: 'flex', alignItems: 'center', gap: 5 }}
                    onClick={() => {
                      self.open(
                        FUtil.LinkTo.resourceVersionCreator({
                          resourceID: resourceVersionEditorPage.resourceID,
                        }),
                      );
                    }}
                  >
                    <FIcons.FUpdateVersion style={{ fontSize: 14 }} />
                    {/*<span>更新版本</span>*/}
                    <span>{FI18n.i18nNext.t('edit_resource_vmgnt_btn_update')}</span>
                  </FComponentsLib.FTextBtn>
                </Badge>
              </div>
              <div style={{ height: 10 }} />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <FComponentsLib.FContentText
                  type='additional2'
                  text={
                    FI18n.i18nNext.t('release_date') +
                    (resourceVersionEditorPage.resourceVersionInfo?.createData || '')
                  }
                />
                <div style={{ width: 40 }} />
              </div>
            </div>

            <div style={{ height: 40 }} />

            <div className={styles.block}>
              <FComponentsLib.FContentText
                // text={'基础属性'}
                text={FI18n.i18nNext.t('resourceinfo_title')}
                type={'highlight'}
              />
              <div style={{ height: 20 }} />
              <div className={styles.baseInfo}>
                <div className={styles.baseInfoLeft}>
                  <div className={styles.baseInfoLeftIcon}>
                    {/*<img src={img_zip} alt={''} style={{ width: 50 }} />*/}
                    <FileIcon
                      mime={resourceVersionEditorPage.resourceVersionFileInfo?.mime || ''}
                      url={
                        FUtil.Format.completeUrlByDomain('api') +
                        `/v2/resources/${resourceVersionEditorPage.resourceID}/versions/${resourceVersionEditorPage.version}/download`
                      }
                    />
                  </div>
                  <div>
                    <FComponentsLib.FContentText
                      text={resourceVersionEditorPage.resourceVersionFileInfo?.fileName}
                      type={'highlight'}
                      style={{ maxWidth: 400 }}
                      singleRow
                    />
                    <div style={{ height: 5 }} />
                    <FComponentsLib.FContentText
                      // text={'ID : 4497c6108a0ac0bc35515cf694987dbbb7fa753b'}
                      text={`${FI18n.i18nNext.t('object_id')}：${
                        resourceVersionEditorPage.resourceVersionFileInfo?.sha1
                      }`}
                      type={'additional2'}
                      style={{ maxWidth: 400 }}
                      singleRow
                    />
                  </div>
                </div>
                <div className={styles.baseInfoRight}>
                  {resourceVersionEditorPage.resourceVersionFileInfo?.mime &&
                    (resourceVersionEditorPage.resourceVersionFileInfo.mime?.startsWith('image/') ||
                      resourceVersionEditorPage.resourceVersionFileInfo.mime?.startsWith(
                        'video/',
                      ) ||
                      resourceVersionEditorPage.resourceVersionFileInfo.mime?.startsWith(
                        'audio/',
                      ) ||
                      resourceVersionEditorPage.resourceVersionFileInfo.mime.includes(
                        'text/plain',
                      ) ||
                      resourceVersionEditorPage.resourceVersionFileInfo.mime.includes(
                        'text/markdown',
                      ) ||
                      resourceVersionEditorPage.resourceVersionFileInfo.mime ===
                        'application/vnd.freelog.comic') && (
                      <div
                        className={styles.baseInfoRightButton}
                        onClick={() => {
                          if (
                            resourceVersionEditorPage.resourceVersionFileInfo?.mime ===
                            'application/vnd.freelog.comic'
                          ) {
                            set$cartoonPreviewerOpen(true);
                            return;
                          }

                          if (
                            resourceVersionEditorPage.resourceVersionFileInfo?.mime.includes(
                              'text/markdown',
                            )
                          ) {
                            set$markdownPreviewerOpen(true);
                            return;
                          }

                          const url: string =
                            FUtil.Format.completeUrlByDomain('api') +
                            `/v2/resources/${resourceVersionEditorPage.resourceID}/versions/${resourceVersionEditorPage.version}/download`;
                          fFilePreviewer({
                            url: url,
                            mime: resourceVersionEditorPage.resourceVersionFileInfo?.mime || '',
                          });
                        }}
                      >
                        <FIcons.FMappingRuleOnline
                          style={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: 'inherit',
                          }}
                        />
                        {/* <span>预览</span> */}
                        <span>{FI18n.i18nNext.t('edit_resource_vmgnt_btn_preview')}</span>
                      </div>
                    )}

                  {resourceVersionEditorPage.resourceInfo?.resourceType[0] === '阅读' &&
                  resourceVersionEditorPage.resourceInfo?.resourceType[1] === '漫画' ? (
                    <FDropdownMenu
                      options={[
                        {
                          text: 'ZIP格式文件',
                          value: 'zip',
                        },
                        {
                          text: 'CBZ格式文件',
                          value: 'cbz',
                        },
                      ]}
                      onChange={(extension) => {
                        // onClickDownload && onClickDownload('.' + value);
                        self.location.href =
                          FUtil.Format.completeUrlByDomain('api') +
                          `/v2/resources/${resourceVersionEditorPage.resourceID}/versions/${resourceVersionEditorPage.version}/download?fileSuffix=.${extension}`;
                      }}
                    >
                      <div className={styles.baseInfoRightButton}>
                        <FIcons.FDownload
                          style={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: 'inherit',
                          }}
                        />
                        {/* <span>下载</span> */}
                        <span>{FI18n.i18nNext.t('edit_resource_vmgnt_btn_download')}</span>
                      </div>
                    </FDropdownMenu>
                  ) : (
                    <div
                      className={styles.baseInfoRightButton}
                      onClick={() => {
                        self.location.href =
                          FUtil.Format.completeUrlByDomain('api') +
                          `/v2/resources/${resourceVersionEditorPage.resourceID}/versions/${resourceVersionEditorPage.version}/download`;
                      }}
                    >
                      <FIcons.FDownload
                        style={{
                          fontSize: 12,
                          fontWeight: 600,
                          color: 'inherit',
                        }}
                      />
                      {/* <span>下载</span> */}
                      <span>{FI18n.i18nNext.t('edit_resource_vmgnt_btn_download')}</span>
                    </div>
                  )}
                </div>
              </div>
              {[
                // ...resourceVersionEditorPage.rawProperties,
                // ...resourceVersionEditorPage.additionalProperties,
                ...resourceVersionEditorPage.systemProperties,
                ...resourceVersionEditorPage.customProperties,
              ].length > 0 && (
                <>
                  <div style={{ height: 20 }} />
                  <FAttrsAndConfigs
                    dateSource={[
                      ...resourceVersionEditorPage.systemProperties.map<IAttrsAndConfigsItem>(
                        (sp) => {
                          return {
                            key: sp.key,
                            value: sp.value,
                            name: sp.name,
                            description: sp.description,
                            configs: {
                              item_Deletable: false,
                              key_Editable: false,
                              name_Editable: false,
                              description_Editable: false,
                              value_Editable: (sp.type === 'additional' && sp.valueConfig) || false,
                            },
                          };
                        },
                      ),
                      ...resourceVersionEditorPage.customProperties.map<IAttrsAndConfigsItem>(
                        (cp) => {
                          return {
                            key: cp.key,
                            value: cp.value,
                            name: cp.name,
                            description: cp.description,
                            configs: {
                              item_Deletable: false,
                              key_Editable: false,
                              name_Editable: false,
                              description_Editable: true,
                              value_Editable: {
                                text: {
                                  nullable: true,
                                  minLength: 0,
                                  maxLength: 100,
                                },
                              },
                            },
                          };
                        },
                      ),
                    ]}
                    onChangeItem={async (oldData, newData, index, changedFields) => {
                      if (index < resourceVersionEditorPage.systemProperties.length) {
                        const newDateSource = [...resourceVersionEditorPage.systemProperties];
                        newDateSource[index] = {
                          key: newData.key,
                          name: newData.name,
                          value: newData.value,
                          description: newData.description,
                          type: resourceVersionEditorPage.systemProperties[index].type,
                          valueConfig:
                            resourceVersionEditorPage.systemProperties[index].valueConfig,
                        };

                        await onChange({
                          systemProperties: newDateSource,
                        });
                      } else {
                        const newDateSource = [...resourceVersionEditorPage.customProperties];
                        newDateSource[index - resourceVersionEditorPage.systemProperties.length] = {
                          key: newData.key,
                          name: newData.name,
                          value: newData.value,
                          description: newData.description,
                        };

                        await onChange({
                          customProperties: newDateSource,
                        });
                      }
                      await dispatch<SyncAllPropertiesAction>({
                        type: 'resourceVersionEditorPage/syncAllProperties',
                        payload: {
                          successMessage: changedFields.includes('value')
                            ? FI18n.i18nNext.t('saved_successfully')
                            : undefined,
                        },
                      });
                    }}
                    disabledKeys={[]}
                    disabledNames={[]}
                  />
                </>
              )}
            </div>

            {resourceVersionEditorPage.customConfigurations.length > 0 && (
              <>
                <div style={{ height: 5 }} />
                <div className={styles.block}>
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.t('resourceoptions_title')}
                    type={'highlight'}
                  />
                  <div style={{ height: 20 }} />
                  <FResourceOptions
                    theme={'dark'}
                    dataSource={resourceVersionEditorPage.customConfigurations.filter((f1, f2) => {
                      return $customOptionsExpansion || f2 < 3;
                    })}
                    onEdit={async (data) => {
                      const index: number =
                        resourceVersionEditorPage.customConfigurations.findIndex((p) => {
                          return p === data;
                        });

                      const dataSource: {
                        key: string;
                        name: string;
                        type: 'input' | 'select';
                        input: string;
                        select: string[];
                        description: string;
                      } | null = await fResourceOptionEditor({
                        disabledKeys: [
                          ...resourceVersionEditorPage.systemProperties.map<string>((rp) => rp.key),
                          ...resourceVersionEditorPage.customProperties.map<string>((bp) => bp.key),
                          ...resourceVersionEditorPage.customConfigurations.map<string>(
                            (pp) => pp.key,
                          ),
                        ],
                        disabledNames: [
                          ...resourceVersionEditorPage.systemProperties.map<string>(
                            (rp) => rp.name,
                          ),
                          ...resourceVersionEditorPage.customProperties.map<string>(
                            (bp) => bp.name,
                          ),
                          ...resourceVersionEditorPage.customConfigurations.map<string>(
                            (pp) => pp.name,
                          ),
                        ],
                        defaultData: data,
                        noneEditableFields: ['key', 'name', 'type'],
                      });

                      if (!dataSource) {
                        return;
                      }
                      await onChange({
                        customConfigurations: resourceVersionEditorPage.customConfigurations.map<
                          ResourceVersionEditorPageModelState['customConfigurations'][number]
                        >((bp, i) => {
                          if (index !== i) {
                            return bp;
                          }
                          return dataSource;
                        }),
                      });
                      await dispatch<SyncAllPropertiesAction>({
                        type: 'resourceVersionEditorPage/syncAllProperties',
                      });
                    }}
                  />
                  {resourceVersionEditorPage.customConfigurations.length > 3 && (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: 5,
                      }}
                    >
                      {$customOptionsExpansion ? (
                        <FComponentsLib.FTextBtn
                          onClick={() => {
                            set$customOptionsExpansion(false);
                          }}
                          style={{ fontSize: 12 }}
                          type={'primary'}
                        >
                          {FI18n.i18nNext.t('resourceoptions_btn_showless', {
                            OptionsQty: resourceVersionEditorPage.customConfigurations.length,
                          })}
                        </FComponentsLib.FTextBtn>
                      ) : (
                        <>
                          <FComponentsLib.FContentText
                            text={'可配置项目较多，已折叠显示'}
                            type={'additional2'}
                          />
                          <FComponentsLib.FTextBtn
                            onClick={() => {
                              set$customOptionsExpansion(true);
                            }}
                            style={{ fontSize: 12 }}
                            type={'primary'}
                          >
                            {FI18n.i18nNext.t('resourceoptions_btn_showall', {
                              OptionsQty: resourceVersionEditorPage.customConfigurations.length,
                            })}
                          </FComponentsLib.FTextBtn>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </>
            )}

            {(resourceVersionEditorPage.directDependencies.length > 0 ||
              resourceVersionEditorPage.baseUpcastResources.length > 0) &&
              resourceVersionEditorPage.reload > 0 && (
                <>
                  <div style={{ height: 5 }} />
                  <div className={styles.block}>
                    {resourceVersionEditorPage.reload > 0 && (
                      <FMicroAPP_Authorization
                        licenseeId={resourceVersionEditorPage.resourceID}
                        licenseeVersion={resourceVersionEditorPage.version}
                        mainAppType={'resourceInfo'}
                        depList={resourceVersionEditorPage.directDependencies}
                        upcastList={resourceVersionEditorPage.baseUpcastResources}
                        // reload={resourceVersionEditorPage.reload}
                        update={(value) => {
                          dispatch<OnUpdate_Data_Action>({
                            type: 'resourceSider/onUpdate_Data',
                            // payload: resourceAuthPage.resourceID,
                          });
                        }}
                      />
                    )}
                  </div>
                </>
              )}

            <div style={{ height: 5 }} />

            <div className={styles.block}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.t('version_description')}
                  type={'highlight'}
                />

                <Space size={10}>
                  {isEditing ? (
                    <>
                      {/*<FComponentsLib.FTextBtn*/}
                      {/*  type='default'*/}
                      {/*  onClick={() => {*/}
                      {/*    onChange({ descriptionFullScreen: true });*/}
                      {/*  }}*/}
                      {/*>全屏编辑</FComponentsLib.FTextBtn>*/}
                      {/*<FDivider />*/}
                      <FComponentsLib.FTextBtn type='default' onClick={() => setIsEditing(false)}>
                        {FI18n.i18nNext.t('cancel')}
                      </FComponentsLib.FTextBtn>
                      <FComponentsLib.FTextBtn
                        type='primary'
                        onClick={() => {
                          const html: string = editor.toHTML();
                          const description: string = html === '<p></p>' ? '' : html;
                          dispatch<ChangeAction>({
                            type: 'resourceVersionEditorPage/change',
                            payload: {
                              description: description,
                            },
                          });
                          dispatch<UpdateDataSourceAction>({
                            type: 'resourceVersionEditorPage/updateDataSource',
                            payload: {
                              description: description,
                            },
                          });
                          setIsEditing(false);
                          if (!description) {
                            onChange({
                              descriptionFullScreen: false,
                            });
                          }
                        }}
                      >
                        {FI18n.i18nNext.t('save')}
                      </FComponentsLib.FTextBtn>
                    </>
                  ) : resourceVersionEditorPage.description !== '' ? (
                    <>
                      {/*<FComponentsLib.FTextBtn*/}
                      {/*  type='default'*/}
                      {/*  onClick={() => {*/}
                      {/*    onChange({ descriptionFullScreen: true });*/}
                      {/*    // const s = self.open();*/}
                      {/*    // s.document.write(buildPreviewHtml(resourceVersionEditorPage.description))*/}
                      {/*  }}*/}
                      {/*>全屏查看</FComponentsLib.FTextBtn>*/}
                      {/*<FDivider />*/}
                      <FComponentsLib.FTextBtn
                        type='primary'
                        onClick={() => {
                          setIsEditing(true);
                        }}
                      >
                        编辑
                      </FComponentsLib.FTextBtn>
                    </>
                  ) : undefined}
                </Space>
              </div>

              {!resourceVersionEditorPage.description && !isEditing && (
                <>
                  <div style={{ height: 10 }} />
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <FComponentsLib.FContentText
                      // text={'动动手，让你的资源看起来更丰富～'}
                      text={FI18n.i18nNext.t('version_description_empty_msg')}
                      type={'additional2'}
                    />
                    <div style={{ height: 20 }} />

                    <FComponentsLib.FRectBtn
                      type={'primary'}
                      onClick={() => {
                        setIsEditing(true);
                      }}
                    >
                      {/*添加版本描述*/}
                      {FI18n.i18nNext.t('version_description_empty_btn')}
                    </FComponentsLib.FRectBtn>
                  </div>
                </>
              )}

              {isEditing ? (
                <>
                  <div style={{ height: 20 }} />

                  <FBraftEditor
                    value={editor}
                    // defaultValue={editorText}
                    onChange={(value: EditorState) => setEditor(value)}
                    style={{ minHeight: 500 }}
                  />
                </>
              ) : (
                resourceVersionEditorPage.description && (
                  <>
                    <div style={{ height: 20 }} />
                    <div className={styles.description}>
                      <FHtmlReactParser str={resourceVersionEditorPage.description} />
                    </div>
                  </>
                )
              )}
            </div>

            {resourceVersionEditorPage.graphShow && (
              <>
                <div style={{ height: 5 }} />
                <div className={styles.block}>
                  <FComponentsLib.FContentText text={'相关视图'} type={'highlight'} />
                  <div style={{ height: 20 }} />

                  <FViewportCards_Resource
                    resourceID={resourceVersionEditorPage.resourceID}
                    version={resourceVersionEditorPage.version}
                    graphShow={['authorization', 'dependency']}
                    onMount={({ hasData }) => {
                      // console.log(hasData, 'hasDataiosdjflkjsdflkjlk');
                      dispatch<ChangeAction>({
                        type: 'resourceVersionEditorPage/change',
                        payload: {
                          graphShow: hasData,
                        },
                      });
                    }}
                  />
                </div>
              </>
            )}
          </div>
          <div style={{ height: 100 }} />
        </div>
      )}

      <FMicroApp_CartoonEditorDrawer
        open={$cartoonPreviewerOpen}
        resourceID={resourceVersionEditorPage.resourceID}
        version={resourceVersionEditorPage.version}
        appMode={'preview'}
        onChange_Saved={(saved) => {}}
        onClose={() => {
          // dispatch<OnClose_step2_editCartoon_Action>({
          //   type: 'resourceCreatorPage/onClose_step2_editCartoon',
          // });
          set$cartoonPreviewerOpen(false);
        }}
      />
      <FMicroApp_MarkdownEditorDrawer
        open={$markdownPreviewerOpen}
        resourceID={resourceVersionEditorPage.resourceID}
        version={resourceVersionEditorPage.version}
        appMode={'preview'}
        onChange_Saved={(saved) => {}}
        onClose={() => {
          // dispatch<OnClose_step2_editCartoon_Action>({
          //   type: 'resourceCreatorPage/onClose_step2_editCartoon',
          // });
          set$markdownPreviewerOpen(false);
        }}
      />
    </>
  );
}

export default withRouter(
  connect(({ resourceVersionEditorPage }: ConnectState) => ({
    resourceVersionEditorPage: resourceVersionEditorPage,
  }))(VersionInfo),
);

// interface HeaderProps {
//   versions: string[];
//   version: string;
//   resourceID: string;
//   sha1: string;
//   signingDate: string;
//   isCartoon: boolean;
//   hasDraft: boolean;
//   mime: string;
//
//   onClickDownload?(type?: string): void;
//
//   onChangeVersion?(version: string): void;
// }
//
// function Header({
//                   mime,
//                   versions,
//                   version,
//                   resourceID,
//                   sha1,
//                   signingDate,
//                   hasDraft,
//                   onClickDownload,
//                   isCartoon,
//                   onChangeVersion,
//                 }: HeaderProps) {
//
//   // const [$cartoonPreviewerOpen, set$cartoonPreviewerOpen, get$cartoonPreviewerOpen] = FUtil.Hook.useGetState<boolean>(false);
//
//   return (
//
//   );
// }

interface FileIconProps {
  mime: string;
  url: string;
}

function FileIcon({ mime, url }: FileIconProps) {
  if (mime?.startsWith('text/')) {
    return <img src={img_txt} alt={''} style={{ width: 50 }} />;
  }

  if (mime?.startsWith('audio/')) {
    return <img src={img_audio} alt={''} style={{ width: 50 }} />;
  }

  // if (mime.startsWith('video/')) {
  //   return (<div style={{ width: 'fit-content', height: 'fit-content' }}>
  //     <video src={url} style={{ width: '100%', maxHeight: '100%' }} />
  //   </div>);
  // }
  if (mime?.startsWith('video/')) {
    return (
      <>
        <video src={url} style={{ width: '100%', maxHeight: '100%' }} />
        <div
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <i
            className={['freelog', 'fl-icon-bofang-daibiankuang'].join(' ')}
            style={{ fontSize: 36, color: 'white' }}
          />
        </div>
      </>
    );
  }

  if (mime?.startsWith('image/')) {
    return <img src={url} alt={''} style={{ width: '100%', maxHeight: '100%' }} />;
  }

  if (
    [
      'application/gzip',
      'application/x-gzip',
      'application/zip',
      'application/rar',
      'application/vnd.rar',
      'application/tar',
      'application/x-tar',
    ].includes(mime)
  ) {
    return <img src={img_zip} alt={''} style={{ width: 50 }} />;
  }

  if (mime?.startsWith('application/pdf')) {
    return <img src={img_pdf} alt={''} style={{ width: 50 }} />;
  }

  if (mime === 'application/vnd.freelog.comic') {
    return <img src={img_cartoon} alt={''} style={{ width: 50 }} />;
  }

  return <img src={img_general} alt={''} style={{ width: 50 }} />;
}
